// import React, { useState } from "react";
// import { Box, Typography, Grid, Paper } from "@mui/material";
// import moment from "moment";
// import logo from '../../../assets/Images/Clanbridge-logo.png2.png';

// const GRNPrintView = React.forwardRef(({ formData, tableData, contentRef }) => {
//     const [currentDate, setCurrentDate] = useState(moment(new Date()).format("DD-MM-YYYY"));
//     return (
//         <Box ref={contentRef} sx={{ p: 3 }}>
//             <Typography variant="h5" align="center" gutterBottom>
//                 Goods Receipt Note
//             </Typography>
//             {logo && (
//                 <>
//                     <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, marginTop: '15px' }}>
//                         <img src={logo} style={{ height: '35px' }} alt="logo" />
//                     </Typography>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                         <Typography variant="body2" align="left" sx={{ marginBottom: '10px' }}>
//                             Address:
//                         </Typography>
//                         <Typography variant="body1" align="right" sx={{ marginBottom: '10px' }}>
//                             Date: {currentDate}
//                         </Typography>
//                     </Box>
//                 </>
//             )}
//             <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
//                 <Typography variant="h6" gutterBottom>
//                     GRN Details
//                 </Typography>

//                 <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>Property:</strong> {formData.PropertyName || '-'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>GRN No:</strong> {formData.SgrnNo || '-'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>GRN Date:</strong> {formData.SgrnDt ? moment(formData.SgrnDt).format("DD-MM-YYYY") : '-'}</Typography>
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                         <Typography><strong>Supplier Name:</strong> {formData.PartyName || '-'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={6}>
//                         <Typography><strong>Branch:</strong> {formData.PartyDtlName || '-'}</Typography>
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                         <Typography><strong>Actual Supplier:</strong> {formData.ActualPartyName || '-'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={6}>
//                         <Typography><strong>Actual Branch:</strong> {formData.ActualPartyDtlName || '-'}</Typography>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>Challan No:</strong> {formData.ChallanNo || '-'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>Challan Date:</strong> {formData.ChallanDt ? moment(formData.ChallanDt).format("DD-MM-YYYY") : '-'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>Reference No:</strong> {formData.RefNo || '-'}</Typography>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>Transporter:</strong> {formData.TrspName || '-'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>LR No:</strong> {formData.LrNo || '-'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>LR Date:</strong> {formData.LrDt ? moment(formData.LrDt).format("DD-MM-YYYY") : '-'}</Typography>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>Broker:</strong> {formData.BrokerName || '-'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>Total Quantity:</strong> {formData.Quantity || '0.00'}</Typography>
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                         <Typography><strong>Total Amount:</strong> {formData.Amount || '0.00'}</Typography>
//                     </Grid>

//                     <Grid item xs={12}>
//                         <Typography><strong>Remark:</strong> {formData.Remark || '-'}</Typography>
//                     </Grid>
//                 </Grid>
//             </Paper>

//             {/* Table Data Section */}
//             <Paper elevation={3} sx={{ p: 3 }}>
//                 <Typography variant="h6" gutterBottom>
//                     Item Details
//                 </Typography>

//                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                     <thead>
//                         <tr style={{ backgroundColor: '#f5f5f5' }}>
//                             <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Category</th>
//                             <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Group</th>
//                             <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>SubGroup</th>
//                             <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Item Name</th>
//                             <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Unit</th>
//                             <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>Quantity</th>
//                             <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>Rate</th>
//                             <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>Amount</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {tableData.map((row, index) => (
//                             <tr key={index}>
//                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.ItmCatName || '-'}</td>
//                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.ItmGrpName || '-'}</td>
//                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.ItmSubGrpName || '-'}</td>
//                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.ItmName || '-'}</td>
//                                 <td style={{ padding: '8px', border: '1px solid #ddd' }}>{row.UnitName || '-'}</td>
//                                 <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.Quantity || '0.00'}</td>
//                                 <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.Rate || '0.00'}</td>
//                                 <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{row.Amount || '0.00'}</td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </Paper>
//         </Box>
//     );
// });

// export default GRNPrintView;




import React, { useState } from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import moment from "moment";
import logo from '../../../assets/Images/Clanbridge-logo.png2.png';

const GRNPrintView = React.forwardRef(({ formData, tableData, contentRef }) => {
    console.log('formDataprint',formData)
    const [currentDate] = useState(moment(new Date()).format("DD-MM-YYYY"));
    
    return (
        <Box ref={contentRef} sx={{ p: 3, fontFamily: '"Helvetica Neue", Arial, sans-serif' }}>
            {/* Header Section with Colorful Design */}
            <Box sx={{ 
                backgroundColor: '#1976d2', 
                color: 'white',
                padding: '15px',
                borderRadius: '4px 4px 0 0',
                marginBottom: '20px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
            }}>
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    flexWrap: 'wrap'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {logo && (
                            <img 
                                src={logo} 
                                style={{ 
                                    height: '50px', 
                                    marginRight: '15px',
                                    filter: 'brightness(0) invert(1)'
                                }} 
                                alt="logo" 
                            />
                        )}
                        <Box>
                            <Typography variant="h4" sx={{ 
                                fontWeight: 'bold',
                                marginBottom: '5px',
                                color: 'white'
                            }}>
                                GOODS RECEIPT NOTE
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                                {formData.PropertyName || 'All Properties'}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="body1" sx={{ 
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            padding: '5px 10px',
                            borderRadius: '4px',
                            marginBottom: '5px'
                        }}>
                            <strong>GRN No:</strong> {formData.SgrnNo || 'N/A'}
                        </Typography>
                        <Typography variant="body1">
                            <strong>Date:</strong> {currentDate}
                        </Typography>
                    </Box>
                </Box>
            </Box>


            <Box sx={{ 
                backgroundColor: '#f5f5f5',
                padding: '10px 15px',
                borderRadius: '4px',
                marginBottom: '20px',
                borderLeft: '4px solid #1976d2'
            }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    Clanbridge Technologies Pvt. Ltd.
                </Typography>
                <Typography variant="body2">
                    123 Business Park, Sector 22, Gurugram, Haryana 122001
                </Typography>
                <Typography variant="body2">
                    Phone: +91 9876543210 | Email: info@clanbridge.com
                </Typography>
            </Box>

            <Paper elevation={0} sx={{ 
                p: 3, 
                mb: 3,
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                position: 'relative',
                '&:before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '5px',
                    height: '100%',
                    backgroundColor: '#4caf50'
                }
            }}>
                <Typography variant="h6" gutterBottom sx={{ 
                    color: '#1976d2',
                    borderBottom: '2px solid #1976d2',
                    paddingBottom: '5px',
                    display: 'inline-block'
                }}>
                    GRN Details
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <Typography>
                            <span style={{ color: '#1976d2', fontWeight: 'bold' }}>Property:</span> {formData.PropertyName || '-'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography>
                            <span style={{ color: '#1976d2', fontWeight: 'bold' }}>GRN Date:</span> {formData.SgrnDt ? moment(formData.SgrnDt).format("DD-MM-YYYY") : '-'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography>
                            <span style={{ color: '#1976d2', fontWeight: 'bold' }}>Reference No:</span> {formData.RefNo || '-'}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box sx={{ 
                            backgroundColor: '#f9f9f9',
                            padding: '10px',
                            borderRadius: '4px',
                            borderLeft: '3px solid #ff9800'
                        }}>
                            <Typography variant="subtitle2" sx={{ color: '#ff9800', fontWeight: 'bold' }}>
                                SUPPLIER INFORMATION
                            </Typography>
                            <Typography>
                                <strong>Name:</strong> {formData.PartyName || '-'}
                            </Typography>
                            <Typography>
                                <strong>Branch:</strong> {formData.PartyDtlName || '-'}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ 
                            backgroundColor: '#f9f9f9',
                            padding: '10px',
                            borderRadius: '4px',
                            borderLeft: '3px solid #9c27b0'
                        }}>
                            <Typography variant="subtitle2" sx={{ color: '#9c27b0', fontWeight: 'bold' }}>
                                ACTUAL SUPPLIER
                            </Typography>
                            <Typography>
                                <strong>Name:</strong> {formData.ActualPartyName || '-'}
                            </Typography>
                            <Typography>
                                <strong>Branch:</strong> {formData.ActualPartyDtlName || '-'}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Typography>
                            <span style={{ color: '#1976d2', fontWeight: 'bold' }}>Challan No:</span> {formData.ChallanNo || '-'}
                        </Typography>
                        <Typography>
                            <span style={{ color: '#1976d2', fontWeight: 'bold' }}>Challan Date:</span> {formData.ChallanDt ? moment(formData.ChallanDt).format("DD-MM-YYYY") : '-'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography>
                            <span style={{ color: '#1976d2', fontWeight: 'bold' }}>Transporter:</span> {formData.TrspName || '-'}
                        </Typography>
                        <Typography>
                            <span style={{ color: '#1976d2', fontWeight: 'bold' }}>Broker:</span> {formData.BrokerName || '-'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography>
                            <span style={{ color: '#1976d2', fontWeight: 'bold' }}>LR No:</span> {formData.LrNo || '-'}
                        </Typography>
                        <Typography>
                            <span style={{ color: '#1976d2', fontWeight: 'bold' }}>LR Date:</span> {formData.LrDt ? moment(formData.LrDt).format("DD-MM-YYYY") : '-'}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box sx={{ 
                            backgroundColor: '#e8f5e9',
                            padding: '10px',
                            borderRadius: '4px',
                            textAlign: 'center'
                        }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
                                TOTAL QUANTITY: {formData.Quantity || '0.00'}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ 
                            backgroundColor: '#e3f2fd',
                            padding: '10px',
                            borderRadius: '4px',
                            textAlign: 'center'
                        }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1565c0' }}>
                                TOTAL AMOUNT: {formData.Amount || '0.00'}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{ 
                            backgroundColor: '#fff3e0',
                            padding: '10px',
                            borderRadius: '4px',
                            marginTop: '10px'
                        }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#e65100' }}>
                                REMARKS:
                            </Typography>
                            <Typography>
                                {formData.Remark || 'No remarks'}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            {/* Item Details Section */}
            <Paper elevation={0} sx={{ 
                p: 0, 
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                overflow: 'hidden'
            }}>
                <Box sx={{ 
                    backgroundColor: '#1976d2',
                    color: 'white',
                    padding: '10px 15px'
                }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        ITEM DETAILS
                    </Typography>
                </Box>
                
                <Box sx={{ overflowX: 'auto' }}>
                    <table style={{ 
                        width: '100%', 
                        borderCollapse: 'collapse',
                        fontFamily: '"Helvetica Neue", Arial, sans-serif'
                    }}>
                        <thead>
                            <tr style={{ 
                                backgroundColor: '#f5f5f5',
                                borderBottom: '2px solid #1976d2'
                            }}>
                                {['Category', 'Group', 'SubGroup', 'Item Name', 'Unit', 'Quantity', 'Rate', 'Amount'].map((header, index) => (
                                    <th key={index} style={{ 
                                        padding: '12px 8px', 
                                        textAlign: index >= 5 ? 'right' : 'left',
                                        color: '#1976d2',
                                        fontWeight: 'bold'
                                    }}>
                                        {header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData?.map((row, index) => (
                                <tr key={index} style={{ 
                                    borderBottom: '1px solid #e0e0e0',
                                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9'
                                }}>
                                    <td style={{ padding: '10px 8px' }}>{row.ItmCatName || '-'}</td>
                                    <td style={{ padding: '10px 8px' }}>{row.ItmGrpName || '-'}</td>
                                    <td style={{ padding: '10px 8px' }}>{row.ItmSubGrpName || '-'}</td>
                                    <td style={{ padding: '10px 8px' }}>{row.ItmName || '-'}</td>
                                    <td style={{ padding: '10px 8px' }}>{row.UnitName || '-'}</td>
                                    <td style={{ padding: '10px 8px', textAlign: 'right' }}>{row.Quantity || '0.00'}</td>
                                    <td style={{ padding: '10px 8px', textAlign: 'right' }}>{row.Rate || '0.00'}</td>
                                    <td style={{ 
                                        padding: '10px 8px', 
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: '#2e7d32'
                                    }}>
                                        {row.Amount || '0.00'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
            </Paper>

            {/* Footer Section */}
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between',
                marginTop: '30px',
                paddingTop: '15px',
                borderTop: '1px dashed #bdbdbd'
            }}>
                <Box sx={{ width: '45%', textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ 
                        borderTop: '1px solid #bdbdbd',
                        paddingTop: '10px',
                        fontWeight: 'bold'
                    }}>
                        Received By
                    </Typography>
                </Box>
                <Box sx={{ width: '45%', textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ 
                        borderTop: '1px solid #bdbdbd',
                        paddingTop: '10px',
                        fontWeight: 'bold'
                    }}>
                        Authorized Signatory
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
});

export default GRNPrintView;